export const WEBHOOKS_ENDPOINTS = {
  LIST: '/app/v1/integrations/',
  DETAIL: (integrationId: number) => `/app/v1/integrations/${integrationId}/`,
  EXTENSION_PATCH: (integrationId: number, extId: number) =>
    `/app/v1/integrations/${integrationId}/extensions/${extId}/`,
  AUTH_KEYS: (pbxId: number) => `/app/v1/pbxes/${pbxId}/integration-auth-keys/`,
  AUTH_KEYS_GENERATE: (pbxId: number) =>
    `/app/v1/pbxes/${pbxId}/integration-auth-keys/generate/`,
  AUTH_KEYS_REGENERATE: (pbxId: number) =>
    `/app/v1/pbxes/${pbxId}/integration-auth-keys/regenerate/`,
} as const
